import { FC } from "react";

interface IconProps {
  size?: number;
  color?: string;
}

export const ChatIcon: FC<IconProps> = ({ size = 20, color = "#7D8690" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 8.11C2.5 10.6058 4.34917 12.7183 7.5 13.4467V16.6667L12.1542 13.5167C15.5133 12.8658 17.5 10.695 17.5 8.11C17.5 5.0125 14.6542 2.5 10 2.5C5.34583 2.5 2.5 5.0125 2.5 8.11Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HeartOutlineIcon: FC<IconProps> = ({ size = 20, color = "#7D8690" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 5.39019C10.3242 4.73531 11.3175 4 12.83 4C15.4758 4 17.25 6.42125 17.25 8.67594C17.25 13.3893 11.2317 17 9.75 17C8.26833 17 2.25 13.3893 2.25 8.67594C2.25 6.42125 4.02417 4 6.67 4C8.1825 4 9.17583 4.73531 9.75 5.39019Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ZapIcon: FC<IconProps> = ({ size = 20, color = "#7D8690" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8065 2.5L3.95898 11.6667H10.0007L9.19482 17.5L16.0423 8.33333H10.0007L10.8065 2.5Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShareIcon: FC<IconProps> = ({ size = 20, color = "#7D8690" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4993 7.5H14.166C15.0865 7.5 15.8327 8.18401 15.8327 9.02778V15.1389C15.8327 15.9827 15.0865 16.6667 14.166 16.6667H5.83268C4.91221 16.6667 4.16602 15.9827 4.16602 15.1389V9.02778C4.16602 8.18401 4.91221 7.5 5.83268 7.5H7.49935"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.99887 12.5042V2.5" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.5021 5.00104L10.001 2.5L7.5 5.00104"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookmarkIcon: FC<IconProps> = ({ size = 20, color = "#7D8690" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.42869 3H13.5713C14.3601 3 15 3.62689 15 4.4V17L10.0068 14.4543L5 17V4.4C5 3.62689 5.63995 3 6.42869 3Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhotoIcon: FC<IconProps> = ({ size = 24, color = "#9AA0B4" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 17.4854L7.612 12.8734C8.003 12.4824 8.636 12.4824 9.026 12.8734L10.432 14.2794L15.009 9.70341C15.4 9.31241 16.033 9.31241 16.423 9.70341L21 14.2804"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.51517 7.40671C8.66161 7.55316 8.66161 7.79059 8.51517 7.93704C8.36872 8.08349 8.13128 8.08349 7.98483 7.93704C7.83839 7.79059 7.83839 7.55316 7.98483 7.40671C8.13128 7.26026 8.36872 7.26026 8.51517 7.40671"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

